import React from "react";
import { motion } from "framer-motion";
import { MousePointerClick, Zap, PackageCheck } from "lucide-react";

const steps = [
  { icon: MousePointerClick, num: "01", title: "Select Your Collection", desc: "Pick from our three handpicked premium catalogs — curated for every festive need." },
  { icon: Zap, num: "02", title: "Instant Dispatch", desc: "Express orders are routed to priority fulfilment hubs immediately, no delays." },
  { icon: PackageCheck, num: "03", title: "48-Hour Delivery", desc: "Hand-delivered with precision and care, right in time for Diwali celebrations." },
];

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="relative z-10 scroll-mt-28 bg-[#0d1220] py-24 md:py-32" data-testid="how-it-works-section">
      <div className="pointer-events-none absolute right-0 top-0 h-96 w-96 bloom-gold opacity-30" />
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-16 text-center"
        >
          <span className="font-sans text-xs uppercase tracking-[0.3em] text-[#D4AF37]">The 2-day guarantee</span>
          <h2 className="mx-auto mt-5 max-w-3xl font-serif text-4xl leading-[1.08] tracking-tight text-[#F3EEE3] md:text-5xl">
            Effortless gifting in{" "}
            <span className="italic text-[#D4AF37]">three simple steps</span>
          </h2>
        </motion.div>

        <div className="relative grid grid-cols-1 gap-8 md:grid-cols-3">
          {/* connecting line */}
          <div className="pointer-events-none absolute left-0 right-0 top-9 hidden h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent md:block" />
          {steps.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.num}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.6, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] }}
                className="relative flex flex-col items-center text-center"
                data-testid={`step-${i}`}
              >
                <div className="relative z-10 mb-6 flex h-18 w-18 items-center justify-center rounded-full border border-[#D4AF37]/40 bg-[#111826] p-5 text-[#D4AF37] shadow-[0_0_30px_rgba(212,175,55,0.2)]">
                  <Icon className="h-7 w-7" strokeWidth={1.5} />
                </div>
                <span className="font-serif text-sm tracking-[0.2em] text-[#D4AF37]/70">STEP {s.num}</span>
                <h3 className="mt-2 font-serif text-2xl tracking-tight text-[#F3EEE3]">{s.title}</h3>
                <p className="mt-3 max-w-xs font-sans text-sm leading-relaxed text-[#8B93A7]">{s.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
